module.exports = __webpack_public_path__ + "media/purpose/purpose@1x-017a6177.png";